import React from "react";
import classes from "./SubSectionHeader.module.css";

const SubSectionHeader = ({ title, note = "", className = "" }) => {
  return (
    <div className={`${classes["header-container"]} ${className}`}>
      <div>{title}</div>
      {note && <small className={classes.note}>{note}</small>}
    </div>
  );
};

export default SubSectionHeader;
